import { useState, useEffect } from 'react'
import { coinGeckoService } from '../services/coingecko'
import { transformGlobalData } from '../services/coingeckoTransformer'

interface GlobalMetrics {
  totalMarketCap: number
  total24hVolume: number
  btcDominance: number
  activeCryptocurrencies: number
  markets: number
}

export function useGlobalMetrics() {
  const [metrics, setMetrics] = useState<GlobalMetrics | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchMetrics = async () => {
    try {
      setLoading(true)
      setError(null)

      console.log('[GlobalMetrics] Fetching from CoinGecko...')
      const globalData = await coinGeckoService.getGlobalData()
      const transformed = transformGlobalData(globalData)

      console.log('[GlobalMetrics] Successfully fetched global data')
      setMetrics(transformed)
    } catch (err) {
      console.error('Error fetching global metrics:', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch metrics')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchMetrics()

    // Refresh every 2 minutes
    const interval = setInterval(fetchMetrics, 120000)

    return () => clearInterval(interval)
  }, [])

  return { metrics, loading, error, refresh: fetchMetrics }
}
